import * as React from 'react'

import {Route, Routes, useMatch, useNavigate} from 'react-router'

import {useAppSelector} from '../../hooks/redux'

import {anyPermissionExceptOperator} from '../../libs/user'
import {goToInvoices} from '../../services/navigation'
import {RequireAuth} from '../utils/routing'

import {InvoicesTab} from '../../types'

import Headline from '../../../../commons/src/components/headline'
import Tabs from '../../../../commons/src/components/tabs'
import Tab from '../../../../commons/src/components/tabs/Tab'
import PageContentLayout from '../../components/page-content-layout'
import PageHeader from '../../components/page-content-layout/PageHeader'

import ROUTES from '../../routes'
import PagePartial from '../page-partial'

import InvoicesPartial from './invoices-partial'
import InvoicesPartialV2 from './invoices-partial-v2'

const routes = [
  {
    path: InvoicesTab.V2,
    component: InvoicesPartialV2,
    requireAuth: true,
    requiredPermissions: anyPermissionExceptOperator,
  },
  {
    path: InvoicesTab.V1,
    component: InvoicesPartial,
    requireAuth: true,
    requiredPermissions: anyPermissionExceptOperator,
  },
]

const InvoicesPage = () => {
  const authUser = useAppSelector(state => state.auth.user)
  const provider = useAppSelector(state => state.core.provider)
  const isAdminMode = useAppSelector(state => state.auth.isAdminMode)

  const navigate = useNavigate()
  const match = useMatch<'tab', string>({
    path: `${ROUTES.INVOICES}/:tab`,
  })

  const activeTab = match?.params.tab || InvoicesTab.V2

  return (
    <PagePartial>
      <PageContentLayout
        header={
          <PageHeader headline={<Headline size="l" label="Earnings" />}>
            <Tabs
              activeTab={activeTab}
              onChange={tabKey =>
                goToInvoices(navigate, {
                  activeTab: tabKey as InvoicesTab,
                  replace: true,
                })
              }
            >
              <Tab label="Orders V2" tabKey={InvoicesTab.V2} />
              <Tab label="Orders V1 (legacy)" tabKey={InvoicesTab.V1} />
            </Tabs>
          </PageHeader>
        }
      >
        <Routes>
          {routes.map(route => (
            <Route
              key="route"
              path={route.path}
              element={
                <RequireAuth
                  isAuthenticated={!!authUser}
                  isPermitted={
                    !route.requiredPermissions ||
                    (!!authUser && route.requiredPermissions.includes(authUser.permission))
                  }
                  providerExists={!!provider}
                  isAdminMode={isAdminMode}
                >
                  {React.createElement(route.component)}
                </RequireAuth>
              }
            />
          ))}
        </Routes>
      </PageContentLayout>
    </PagePartial>
  )
}

export default InvoicesPage
